import { Container, NavItemContainer, BarIndicator, NavItemLabel } from './NavBar.styled'

export type NavItemType = {
  key: string
  label: string
  icon?: () => JSX.Element
  style?: React.CSSProperties
}

interface Props {
  items: NavItemType[]
  selected?: NavItemType
  onClick: (navItem: NavItemType) => void
  itemWidth?: number
}

export const NavBar = (props: Props): JSX.Element => {
  const { items, selected, onClick, itemWidth = 45 } = props

  const selectedIndex = items.findIndex((item) => item.key == selected?.key)

  const getItemWidth = (index: number): number => {
    const item = items[index]

    let width = itemWidth

    try {
      if (item.style?.width != undefined && typeof item.style.width == 'string') {
        width = parseInt(item.style?.width, 10)
      } else if (item.style?.width != undefined && typeof item.style.width == 'number') {
        width = item.style.width
      }
    } catch (error) {}

    return width
  }

  const getItemLeft = (): number => {
    let left = 0

    for (let index = 0; index < selectedIndex; index++) {
      const width = getItemWidth(index)

      left += width
    }

    return left
  }

  return (
    <Container>
      {items.map((item, index) => (
        <NavItemContainer
          key={item.key}
          onClick={() => onClick(item)}
          style={{ width: getItemWidth(index), ...item.style }}
        >
          {item.icon && <item.icon />}
          <NavItemLabel>{item.label}</NavItemLabel>
        </NavItemContainer>
      ))}

      {selectedIndex != -1 && (
        <BarIndicator style={{ left: getItemLeft() + 8 * selectedIndex, width: getItemWidth(selectedIndex) }} />
      )}
    </Container>
  )
}
